import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getCompanyContent = createAsyncThunk('/company/content', async () => {
    const userId = localStorage.getItem("userId");

    try {
        const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listCompany/${userId}`, {})
        return response.data;
    } catch (err) {
        if (err.response && err.response.status === 401) {
            window.location.href = '/login';
        }
    }
})

export const companySlice = createSlice({
    name: 'company',
    initialState: {
        isLoading: false,
        company : []
    },
    reducers: {


        addNewCompany: (state, action) => {
            let {newCompanyObj} = action.payload
            state.company = [...state.company, newCompanyObj]
        },

        deleteCompany: (state, action) => {
            let {index} = action.payload
            state.company.splice(index, 1)
        }
    },

    /*extraReducers: {
        [getCompanyContent.pending]: state => {
			state.isLoading = true
		},
        [getCompanyContent.fulfilled]: (state, action) => {
			state.company = action.payload.data
			state.isLoading = false
		},
        [getCompanyContent.rejected]: state => {
			state.isLoading = false
		},
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getCompanyContent.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getCompanyContent.fulfilled, (state, action) => {
                state.company = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getCompanyContent.rejected, (state) => {
                state.isLoading = false;
            });
    }
})

export const { addNewCompany, deleteCompany } = companySlice.actions

export default companySlice.reducer